const { PERMISSIONS } = require('./permissions');
const PERMISSION_BY_MODULE = {
  // ai
  AI: [
    PERMISSIONS.AI_MANAGEMENT // whole page permission
  ],
  // dashboard
  DASHBOARD: [
    PERMISSIONS.DASHBOARD_BRANCH, // whole page permission
    PERMISSIONS.DASHBOARD_OVERALL, // whole page permission
    PERMISSIONS.DASHBOARD_POINT, // whole page permission
    PERMISSIONS.DASHBOARD_COUPON, // whole page permission
    PERMISSIONS.DASHBOARD_PACKAGE, // whole page permission
    PERMISSIONS.DASHBOARD_PROMOTION, // whole page permission
    PERMISSIONS.DASHBOARD_WALLET, // whole page permission
    PERMISSIONS.DASHBOARD_SALES, // whole page permission
    PERMISSIONS.DASHBOARD_GROUP // whole page permission
  ],

  // member
  MEMBER: [
    PERMISSIONS.MEMBER_MANAGE_ADMIN, // page permission
    PERMISSIONS.MEMBER_VIEW, // page permission
    PERMISSIONS.MEMBER_INVITE, // page permission
    PERMISSIONS.MEMBER_VIEW_GROUPS, // page permission
    PERMISSIONS.MEMBER_CREATE_GROUPS, // action
    PERMISSIONS.MEMBER_EDIT_GROUPS, // action
    PERMISSIONS.MEMBER_EDIT_CUSTOMER_GROUPS, // action
    PERMISSIONS.MEMBER_DELETE_GROUPS, // action
    PERMISSIONS.MEMBER_CONFIG_TIERS, // action
    PERMISSIONS.MEMBER_TOGGLE_GROUP_HOME_DISPLAY, // action
    PERMISSIONS.MEMBER_INVITE_TO_GROUP, // action,
    PERMISSIONS.MEMBER_EDIT_PROFILE, // action
    PERMISSIONS.MEMBER_CREATE, // action
    PERMISSIONS.MEMBER_VIEW_GROUP_HISTORY // page permission; customer history tab
  ],

  // deposit
  DEPOSIT: [
    PERMISSIONS.DEPOSIT_VIEW, // page permission
    PERMISSIONS.DEPOSIT_CREATE, // action
    PERMISSIONS.DEPOSIT_EDIT, // action
    PERMISSIONS.DEPOSIT_DELETE // action
  ],

  MGM: [
    PERMISSIONS.MGM_MANAGEMENT, // whole page permission
    PERMISSIONS.MGM_VIEW_HISTORY, // whole page permission
    PERMISSIONS.MGM_VIEW_REPORT, // whole page permission
    PERMISSIONS.MGM_VIEW_CUSTOMER_HISTORY // page permission; customer history tab
  ],

  FUNSHARING: [
    PERMISSIONS.FUNSHARING_VIEW_LIST, // page permission
    PERMISSIONS.FUNSHARING_CREATE, // action
    PERMISSIONS.FUNSHARING_EDIT, // action
    PERMISSIONS.FUNSHARING_VIEW_HISTORY, // page permission
    PERMISSIONS.FUNSHARING_VIEW_REPORT, // page permission
    PERMISSIONS.FUNSHARING_VIEW_CUSTOMER_HISTORY // page permission; customer history tab
  ],

  SMART_POS: [
    PERMISSIONS.SMART_POS_FULL_ACCESS // whole page permission
  ],

  MINIPOS: [
    PERMISSIONS.MINIPOS_ACCESS // whole page permission
  ],

  // branch
  BRANCH: [
    PERMISSIONS.BRANCH_VIEW, // page permission
    PERMISSIONS.BRANCH_EDIT, // action
    PERMISSIONS.BRANCH_MANAGEMENT,
    PERMISSIONS.BRANCH_INVITE // action
  ],

  // contact
  CONTACT: [
    PERMISSIONS.CONTACT_TEMPLATE_MANAGEMENT, // whole page permission
    PERMISSIONS.CONTACT_VIEW,
    PERMISSIONS.CONTACT_CAN_ASSIGN,
    PERMISSIONS.CONTACT_CAN_EDIT_BOARD
  ],

  // advertisement
  ADVERTISEMENT: [
    PERMISSIONS.ADVERTISEMENT_VIEW_LIST, // page permission
    PERMISSIONS.ADVERTISEMENT_CREATE, // action
    PERMISSIONS.ADVERTISEMENT_EDIT, // action
    PERMISSIONS.ADVERTISEMENT_DELETE // action
  ],

  // broadcast
  BROADCAST: [
    PERMISSIONS.BROADCAST_VIEW, // page permission
    PERMISSIONS.BROADCAST_VIEW_HISTORY, // page permission
    PERMISSIONS.BROADCAST_CREATE_WHATSAPP, // action
    PERMISSIONS.BROADCAST_CREATE_LINE, // action
    PERMISSIONS.BROADCAST_EDIT, // action
    PERMISSIONS.BROADCAST_DELETE, // action
    PERMISSIONS.BROADCAST_RECURRING_VIEW, // page permission
    PERMISSIONS.BROADCAST_RECURRING_CREATE, // action
    PERMISSIONS.BROADCAST_RECURRING_EDIT, // action
    PERMISSIONS.BROADCAST_RECURRING_CHANGE_STATUS, // action
    PERMISSIONS.BROADCAST_RECURRING_VIEW_HISTORY // page permission
  ],

  // shop product
  SHOP_PRODUCT: [
    PERMISSIONS.SHOP_PRODUCT_VIEW_LIST, // page permission
    PERMISSIONS.SHOP_PRODUCT_CREATE, // action
    PERMISSIONS.SHOP_PRODUCT_EDIT, // action
    PERMISSIONS.SHOP_PRODUCT_VIEW_CATEGORY, // page permission
    PERMISSIONS.SHOP_PRODUCT_CREATE_CATEGORY, // action
    PERMISSIONS.SHOP_PRODUCT_EDIT_CATEGORY, // action
    PERMISSIONS.SHOP_PRODUCT_DELETE_CATEGORY, // action
    PERMISSIONS.SHOP_PRODUCT_CHANGE_STATUS, // action
    PERMISSIONS.SHOP_PRODUCT_VIEW_STOCK, // page permission
    PERMISSIONS.SHOP_PRODUCT_VIEW_STOCK_HISTORY, // action
    PERMISSIONS.SHOP_PRODUCT_EDIT_STOCK, // action
    PERMISSIONS.SHOP_PRODUCT_ADD_ON_VIEW, // page permission
    PERMISSIONS.SHOP_PRODUCT_ADD_ON_CREATE, // action
    PERMISSIONS.SHOP_PRODUCT_ADD_ON_EDIT, // action
    PERMISSIONS.SHOP_PRODUCT_ADD_ON_GROUP_VIEW, // action
    PERMISSIONS.SHOP_PRODUCT_ADD_ON_GROUP_CREATE, // action
    PERMISSIONS.SHOP_PRODUCT_ADD_ON_GROUP_EDIT, // action
    PERMISSIONS.SHOP_PRODUCT_ADD_ON_GROUP_DELETE // action
  ],

  // shopping cart
  SHOPPING_CART: [
    PERMISSIONS.SHOPPING_PAYMENT_SETTING_VIEW, // page permission
    PERMISSIONS.SHOPPING_PAYMENT_SETTING_EDIT, // action
    PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_VIEW, // page permission
    PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_CREATE, // page permission
    PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_EDIT, // action
    PERMISSIONS.SHOPPING_SHIPPING_MANAGEMENT_DELETE,
    PERMISSIONS.SHOPPING_CART_SETTING_VIEW, // page permission : VAT, Service charge, etc
    PERMISSIONS.SHOPPING_CART_SETTING_EDIT, // action : VAT, Service charge, etc
    PERMISSIONS.SHOPPING_ORDER_MANAGEMENT, // whole page permission : VAT, Service charge, etc
    PERMISSIONS.SHOPPING_ORDER_VIEW,
    PERMISSIONS.SHOPPING_ORDER_CREATE
  ],

  // booking
  BOOKING: [
    PERMISSIONS.BOOKING_VIEW_LIST, //whole page permission and action view
    PERMISSIONS.BOOKING_MANAGEMENT, //action edit
    PERMISSIONS.BOOKING_SETTING, // whole page permission
    PERMISSIONS.BOOKING_INVITE // whole page permission
  ],

  // booking2
  BOOKING2: [
    PERMISSIONS.BOOKING2_VIEW_LIST, // whole page permission
    PERMISSIONS.BOOKING2_MANAGEMENT, // action edit
    PERMISSIONS.BOOKING2_SETTING, // whole page permission
    PERMISSIONS.BOOKING2_INVITE, // whole page permission
    PERMISSIONS.BOOKING2_CREATE // whole page permission
  ],

  // package
  PACKAGE: [
    PERMISSIONS.PACKAGE_VIEW, // page permission
    PERMISSIONS.PACKAGE_CREATE, // action
    PERMISSIONS.PACKAGE_EDIT, // action
    PERMISSIONS.PACKAGE_CHANGE_STATUS, // action
    PERMISSIONS.PACKAGE_REDEEM, // action
    PERMISSIONS.PACKAGE_VIEW_CUSTOMER_ITEMS, // page permission
    PERMISSIONS.PACKAGE_CREATE_CUSTOMER_ITEMS, //action
    PERMISSIONS.PACKAGE_EDIT_CUSTOMER_ITEMS, //action
    PERMISSIONS.PACKAGE_DELETE_CUSTOMER_ITEMS, //action
    PERMISSIONS.PACKAGE_VIEW_CUSTOMER_HISTORY // page permission; customer history tab
  ],

  // promotion
  PROMOTION: [
    PERMISSIONS.PROMOTION_VIEW, // page permission
    PERMISSIONS.PROMOTION_CREATE, // action
    PERMISSIONS.PROMOTION_EDIT, // action
    PERMISSIONS.PROMOTION_CHANGE_STATUS, // action
    PERMISSIONS.PROMOTION_VIEW_CUSTOMERS // action
  ],

  // auto promotion
  AUTO_PROMOTION: [
    PERMISSIONS.AUTO_PROMOTION_VIEW, // page permission
    PERMISSIONS.AUTO_PROMOTION_CREATE, // action
    PERMISSIONS.AUTO_PROMOTION_EDIT, // action
    PERMISSIONS.AUTO_PROMOTION_CHANGE_STATUS // action
  ],

  // coupon
  COUPON: [
    PERMISSIONS.COUPON_VIEW, // page permission
    PERMISSIONS.COUPON_CREATE, // action
    PERMISSIONS.COUPON_EDIT, // action
    PERMISSIONS.COUPON_CHANGE_STATUS, // action
    PERMISSIONS.COUPON_VIEW_HISTORY, // action; 1. management page 2. customer history
    PERMISSIONS.COUPON_VIEW_CUSTOMER_HISTORY, // page permission; customer history tab
    PERMISSIONS.COUPON_USE_FOR_CUSTOMERS // action; use-coupon button in customer history tab
  ],

  // recommender qr
  RECOMMENDER_QR: [
    PERMISSIONS.RECOMMENDER_QR_VIEW, // page permission
    PERMISSIONS.RECOMMENDER_QR_CREATE, // action
    PERMISSIONS.RECOMMENDER_QR_EDIT, // action
    PERMISSIONS.RECOMMENDER_QR_DELETE // action
  ],

  // point
  POINT: [
    PERMISSIONS.POINT_HISTORY, // action for a page with no page-level permission
    PERMISSIONS.POINT_ADD_BY_CUSTOMER, // foreign module page action
    PERMISSIONS.POINT_ADD_BY_PHONE, // foreign module page action
    PERMISSIONS.POINT_ADD_BY_QR, // whole page permission
    PERMISSIONS.POINT_ADD_BY_PERMANENT_QR,
    PERMISSIONS.POINT_ADD_BY_PERMANENT_QR_DELETE, // action delete
    PERMISSIONS.POINT_ADD_BY_PERMANENT_QR_CREATE, // action create
    PERMISSIONS.POINT_VIEW_CUSTOMER_HISTORY, // page permission; customer history tab
    PERMISSIONS.POINT_EXPIRABLE_VIEW_CUSTOMER_HISTORY, // page permission; customer expiring points tab
    PERMISSIONS.POINT_CLEAR_ALL, // action; destructive, clears points for every customer
    PERMISSIONS.POINT_CLEAR_ACCUMULATED, // action; destructive, clears accumulated points for every customer
    PERMISSIONS.SALES_CLEAR_ALL // action; destructive, clears sales totals for every customer
  ],

  // wallet
  WALLET: [
    PERMISSIONS.WALLET_HISTORY, // action for a page with no page-level permission
    PERMISSIONS.WALLET_ADD_BY_CUSTOMER, // foreign module page action
    PERMISSIONS.WALLET_ADD_BY_PHONE, // foreign module page action
    PERMISSIONS.WALLET_ADD_BY_QR, // whole page permission (wallet QR generator)
    PERMISSIONS.WALLET_VIEW_CUSTOMER_HISTORY, // page permission; customer history tab
    PERMISSIONS.WALLET_EXPIRABLE_VIEW_CUSTOMER_HISTORY // page permission; customer expiring wallet tab
  ],

  UPLOAD: [
    PERMISSIONS.UPLOAD_ACCESS,
    PERMISSIONS.UPLOAD_ADD_POINT,
    PERMISSIONS.UPLOAD_ADD_MEMBER,
    PERMISSIONS.UPLOAD_ADD_GROUP,
    PERMISSIONS.UPLOAD_ADD_SHOP_PRODUCT,
    PERMISSIONS.UPLOAD_ADD_DEPOSIT,
    PERMISSIONS.UPLOAD_UPDATE_DEPOSIT,
    PERMISSIONS.UPLOAD_ADD_PACKAGE,
    PERMISSIONS.UPLOAD_ADD_PROMOTION,
    PERMISSIONS.UPLOAD_ADD_COUPON,
    PERMISSIONS.UPLOAD_ADD_SHOP_PRODUCT_STOCK,
    PERMISSIONS.UPLOAD_ADD_SHOP_PRODUCT_CATEGORY
  ],

  // TODO: add modules for Report, Upload files
  REPORT: [
    PERMISSIONS.REPORT_ACCESS,
    PERMISSIONS.REPORT_CUSTOMER_DETAIL,
    PERMISSIONS.REPORT_ACTIVITY,
    PERMISSIONS.REPORT_POINT_HISTORY,
    PERMISSIONS.REPORT_WALLET_HISTORY,
    PERMISSIONS.REPORT_SALES_HISTORY,
    PERMISSIONS.REPORT_REDEEM,
    PERMISSIONS.REPORT_COUPON_SHOP,
    PERMISSIONS.REPORT_COUPON_USAGE,
    PERMISSIONS.REPORT_PACKAGE_SHOP,
    PERMISSIONS.REPORT_PACKAGE_CUSTOMER,
    PERMISSIONS.REPORT_PACKAGE_USAGE_HISTORY,
    PERMISSIONS.REPORT_DEPOSIT_HISTORY,
    PERMISSIONS.REPORT_BOOKING_HISTORY,
    PERMISSIONS.REPORT_BOOKING2_HISTORY,
    PERMISSIONS.REPORT_ORDER_DETAIL,
    PERMISSIONS.REPORT_ORDER_ITEMS,
    PERMISSIONS.REPORT_ORDER_SUMMARY,
    PERMISSIONS.REPORT_STOCK_INVENTORY,
    PERMISSIONS.REPORT_STOCK_TRANSACTION,
    PERMISSIONS.REPORT_COMMISSION_ENTRIES,
    PERMISSIONS.REPORT_COMMISSION_SUMMARY,
    PERMISSIONS.REPORT_GROUP_MEMBERSHIP
  ],

  // notification
  NOTIFICATION: [
    PERMISSIONS.NOTIFICATION_VIEW // page permission
  ],

  // setting
  SETTING: [
    PERMISSIONS.SETTING_SHOP_VIEW, // page permission
    PERMISSIONS.SETTING_SHOP_EDIT, // action
    PERMISSIONS.SETTING_NEW_USER_VIEW, // page permission
    PERMISSIONS.SETTING_NEW_USER_EDIT, // action
    PERMISSIONS.SETTING_CONVERSION_RATE_VIEW,
    PERMISSIONS.SETTING_CONVERSION_RATE_EDIT,
    PERMISSIONS.SETTING_THEME_VIEW, // page permission
    PERMISSIONS.SETTING_THEME_EDIT, // action
    PERMISSIONS.SETTING_SHORTCUT_VIEW, // page permission
    PERMISSIONS.SETTING_SHORTCUT_EDIT, // action
    PERMISSIONS.SETTING_LINE_VIEW, // page permission
    PERMISSIONS.SETTING_LINE_EDIT, // action
    PERMISSIONS.SETTING_CONTACT_VIEW, // page permission
    PERMISSIONS.SETTING_CONTACT_EDIT, // action
    PERMISSIONS.SETTING_NOTIFICATION_VIEW, // page permission
    PERMISSIONS.SETTING_NOTIFICATION_EDIT, // action
    PERMISSIONS.SETTING_CONDITION_VIEW, // page permission
    PERMISSIONS.SETTING_CONDITION_EDIT // action
  ]
};
const MODULE_BY_PERMISSION = Object.entries(PERMISSION_BY_MODULE).reduce((acc, [module, permissions]) => {
  permissions.forEach(permission => {
    acc[permission] = module;
  });
  return acc;
}, {});

Object.freeze(PERMISSION_BY_MODULE);
Object.freeze(MODULE_BY_PERMISSION);

export { PERMISSION_BY_MODULE, MODULE_BY_PERMISSION };
